import React from 'react';
import { ClientGoals, Criteria, Goal } from '../../../models';
import { Badge, ProgressBar } from '../../shared';
import MetricCriteria from './MetricCriteria';

interface MetricCriteriaProps {
  goalSelected: Partial<Goal | ClientGoals>;
  progress: number;
  criterias: Criteria[];
}

function MetricCriterias({
  goalSelected,
  progress,
  criterias,
}: MetricCriteriaProps) {
  return (
    <div className="w-full flex flex-col gap-5 items-center justify-center  ">
      <div className="w-full flex flex-col justify-center  ">
        <div className="flex flex-col lg:flex-row justify-between">
          <span className="font-semibold text-purple-300 text-lg my-2">
            Meta: {goalSelected?.metric}
          </span>
          <div className="mt-2">
            <Badge
              bgClassName="bg-purple-100 "
              textClassName="text-white"
              text={`Objetivo de la meta: ${goalSelected?.target ?? ''}`}
            />
          </div>
        </div>
        <div className="w-full mt-5">
          <ProgressBar progress={progress >= 100 ? 100 : progress} />
        </div>
      </div>
      <div className="w-full flex flex-col lg:flex-row">
        {criterias?.map((criteria, index) => (
          <MetricCriteria
            criteria={criteria}
            active={
              (index === criterias.length - 1 &&
                progress >= criteria.lowerRange) ||
              (progress >= criteria.lowerRange &&
                progress < criteria.upperRange)
            }
          />
        ))}
      </div>
    </div>
  );
}

export default MetricCriterias;
